module.exports = __webpack_public_path__ + "img/1f5c3.1483fb6.svg";